import axios from 'axios';

const getHeaders = (contentType) => ({
  'Content-Type': contentType,
  'Cache-Control': 'no-cache',
  'Greenmile-Module': 'LIVE',
  'Greenmile-Version': App.Version.GMLVersionNumber,
  'Greenmile-Build': App.Version.GMLBuildNumber,
  Pragma: 'no-cache'
});

// to avoid OPTIONS request for GM Chat
const getSimpleRequestHeaders = (contentType) => ({
  'Content-Type': contentType
});

class DefaultRequest {
  constructor({
    url,
    method,
    contentType,
    isFile,
    data,
    success,
    error,
    isSimpleRequest,
    reloadWhenReceiveForbidden = true
  } = {}) {
    const options = {};
    this.url = url || '';
    this.method = method || 'get';
    this.contentType = contentType || 'application/json;charset=utf-8';
    this.isFile = isFile;
    this.data = data;
    this.success = success;
    this.error = error;
    this.isSimpleRequest = isSimpleRequest || false;
    this.reloadWhenReceiveForbidden = reloadWhenReceiveForbidden;

    this.headers = isSimpleRequest
      ? getSimpleRequestHeaders(this.contentType) : getHeaders(this.contentType);

    if (this.responseType) {
      options.responseType = this.responseType;
    }

    options.headers = this.headers;

    this.axiosInstance = axios.create(options);
    this.axiosSource = axios.CancelToken.source();
  }

  abort = () => {
    this.axiosSource.cancel();
  }

  send = async () => {
    const encodedURL = encodeURI(this.url).replace(/#/g, '%23');
    const method = this.method.toLowerCase();

    // Escape html tags and remove script tag
    this.axiosInstance?.interceptors?.response?.use((response) => {
      response.data = JSON.parse(JSON.stringify(response.data).replace(/<script/g, '').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
      return response;
    });

    try {
      const response = await this.axiosInstance.request({
        url: encodedURL,
        method,
        data: this.data,
        cancelToken: this.axiosSource.token
      });

      if (this.success) {
        const data = this.isFile ? new Blob([response.data]) : response.data;
        this.success(data, response.request);
      }

      return response.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error.message);
      } else if (this.error && error.request) {
        this.error(error.request);
      } else {
        console.log(error);
      }

      if (error?.response?.status === 403 && this.reloadWhenReceiveForbidden) {
        window.location.reload();
      }

      return error;
    }
  }
}

export default DefaultRequest;
